import logo from "./logo.svg";
import "./App.css";
import { useTheme } from "./context/ThemeContext";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WebDev from "./pages/services/WebDev";
import DM from "./pages/services/DM";
import Interior from "./pages/services/Interior";
import Blog from "./pages/Blog";
import CaseStudy from "./pages/CaseStudy";
import CaseStudyDetails from "./components/page-components/case-study/CaseStudyDeatiled";
import BlogDetailed from "./components/page-components/blog/BlogDetailed";
import NotFound from "./components/NotFound";
import Chatbot from "./components/Chatbot";
import Internship from "./pages/Internship/Internship";

function App() {
  const { theme, toggleTheme } = useTheme();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetailed />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route path="/case-study/:slug" element={<CaseStudyDetails />} />

        <Route path="/web-development" element={<WebDev />} />
        <Route path="/digital-marketing" element={<DM />} />
        <Route path="/interior-designing" element={<Interior />} />
        <Route path="/polytechnic-internship" element={<Internship />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Chatbot />
      <Footer />
    </>
  );
}

export default App;
